<div class="row">
    <div class="col">
        <div class="confirmation-number">
            {{"cn.yourConfirmationNumberIs"|translate}}
            <span class="stay-box-value" [attr.data-testid]="'confirmation-number'">{{reservation.reservationId}}</span>
        </div>
    </div>
</div>

<div class="row mt-3">
    <div class="col-12 stay-box-container" [attr.data-testid]="'confirmation-table-details'">
        <div class="stay-box">
            {{'cn.Date' | translate}}
            <div class="stay-box-value">{{reservation.searchMask.arrival | date}}</div>
        </div>

        <div class="stay-box">
            {{'cn.Time' | translate}}
            @if (timeBasedEventName) {
                <div class="time-based-event-name">{{timeBasedEventName}}</div>
            }
            <div class="stay-box-value">{{reservation.searchMask.arrival | date:'HH:mm'}}&ndash;{{reservation.searchMask.departure | date:'HH:mm'}}</div>
        </div>
    </div>
</div>

<div class="room-details-container" [attr.data-testid]="'confirmation-table-reservation-details'">
    <div class="room-details-data">
        <div class="row restaurant-row">
            <div class="col-4 col-sm-3">{{'cn.Restaurant' | translate}}</div>
            <div class="col-8 col-sm-9"><b>{{restaurantName}}</b></div>
        </div>

        <div class="row">
            <div class="col-4 col-sm-3">{{'cn.Guests' | translate}}</div>
            <div class="col-8 col-sm-9">
                <span [attr.data-testid]="'confirmation-table-details-adults'">{{reservation.searchMask.adults}} </span>@if (reservation.searchMask.adults > 1) {{{"pr.adults"|translate}}}@else{{{"pr.adult"|translate}}}@if (reservation.searchMask.children > 0) {,
                <span [attr.data-testid]="'confirmation-table-details-children'">{{reservation.searchMask.children}} </span>@if (reservation.searchMask.children == 1) {{{"pr.child"|translate}}}@else{{{"pr.children"|translate}}} }
            </div>
        </div>

        <div class="row">
            <div class="col-4 col-sm-3">{{'cn.Name' | translate}}</div>
            <div class="col-8 col-sm-9">{{reservation.bookerProfile.firstName}} {{reservation.bookerProfile.lastName}}</div>
        </div>

        <div class="row">
            <div class="col-4 col-sm-3">{{'cn.Email' | translate}}</div>
            <div class="col-8 col-sm-9">{{reservation.bookerProfile.emails[0]}}</div>
        </div>

        <div class="row">
            <div class="col-4 col-sm-3">{{'cn.Phone' | translate}}</div>
            <div class="col-8 col-sm-9">{{reservation.bookerProfile.mobilePhoneNumber}}</div>
        </div>
    </div>
</div>
